import { combineReducers } from 'redux'
import sidebar from './sidebar'
import tracks from './tracks'
import currentTrack from './currentTrack'
import audioPlayer from './audioPlayer'

const rootReducer = combineReducers({
  sidebar,
  tracks,
  currentTrack,
  audioPlayer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js